module.exports = __webpack_public_path__ + "img/cluster-bikes.864a1d8d.svg";